export default defineNuxtRouteMiddleware(() => {
    const auth = useAuthStore();
    if (!auth.isLogged) return;

    if (auth.isCourier) return;

    if (auth.isSeller) {
        return navigateTo("/tat/vendedor/Ruta");
    }

    if (auth.isAdmin) {
        return navigateTo("/tat/admin/Dashboard");
    }

    if (auth.isPicker) {
        return navigateTo("/tat/picker/Pedidos");
    }

    return navigateTo("/");
});
